let javaEndPoint = null
if (process.env.NODE_ENV == 'production') { // 生产环境
  let ipData = window.location.hostname
  let portVal = window.location.port
  if (ipData == '365.chinaloyal.cn') {
    if (portVal == '8083') {
      javaEndPoint = "https://"+ ipData +":8096";
    } else {
      javaEndPoint = "https://"+ ipData +":8443";
    }
  } else {
    javaEndPoint = "http://"+ ipData +":8091";
  }
} else {
  // 开发环境
  // let ipVal = 'http://192.168.121.110:8091' //  java测试
  let ipVal = 'http://192.168.121.204:8093' // 本地开发 姜伟
  // let ipVal = 'http://192.168.121.14:8093' // 本地开发 段
  // let ipVal = 'http://47.96.131.222:8091' // 线上
  // let ipVal = 'https://365.chinaloyal.cn:8096' // 小程序线上
  javaEndPoint = ipVal
}
/***
 * 新老版本接口区分字段
*/
const versionsText = '/api/v1'

export {
  javaEndPoint,
  versionsText
}



// WEBPACK FOOTER //
// ./src/common/config.js